import React from 'react';
import styled from 'styled-components';
import { translate } from '../../../../common/translation/translate';
import { CommonContainerStyle } from '../styles';
import { CardDetailsItem } from './cardDetailsItem';

enum CardDetailLabels {
    humidity = 'humidity',
    wind = 'wind',
    dewPoint = 'dewpoint'
}

const hourlyForecastCardDetailItemKey = 'large-hourly-forecast-card-detail-item';

type CardDetailLabelTypes = keyof typeof CardDetailLabels;

type HourCardDetailsProps = {
    [key in CardDetailLabelTypes]: string;
}

export const HourCardDetails = ({ humidity, wind, dewPoint  }: HourCardDetailsProps) => {
    return (
        <Container key='large-hourly-card-details-list'>
            <CardDetailsItem
                key={`${hourlyForecastCardDetailItemKey}${CardDetailLabels.humidity}`}
                hasBackgroundColor={true}
                itemLabel={translate(CardDetailLabels.humidity)}
                itemValue={humidity} />
            <CardDetailsItem
                key={`${hourlyForecastCardDetailItemKey}${CardDetailLabels.wind}`}
                hasBackgroundColor={false}
                itemLabel={translate(CardDetailLabels.wind)}
                itemValue={wind} />
            <CardDetailsItem
                key={`${hourlyForecastCardDetailItemKey}${CardDetailLabels.dewPoint}`}
                hasBackgroundColor={true}
                itemLabel={translate(CardDetailLabels.dewPoint)}
                itemValue={dewPoint} />
        </Container>
    );
};

const Container = styled.ul`
    ${CommonContainerStyle}
    padding: 0;
    height: calc(100% - 142px);
`;